import { render, staticRenderFns } from "./AttributesListsAdd.vue?vue&type=template&id=24e342c3"
import script from "./AttributesListsAdd.vue?vue&type=script&lang=js"
export * from "./AttributesListsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports